import React from 'react';
import {createTheme} from '@mui/material';
import {ToastProvider} from "react-toast-notifications";
import {ThemeProvider} from '@mui/material/styles';
import {blue} from "@mui/material/colors";
import MUIToastContainer from "./components/MUIToastContainer";
import MUIToast from "./components/MUIToast";
import CssBaseline from '@mui/material/CssBaseline';
import 'typeface-roboto';
import AppContent from "./AppContent";
import {Provider} from 'react-redux'
import {store} from './store'

import './App.css';


// Create a theme instance.
const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: blue[700],
            contrastThreshold: 3,
        },
        secondary: {
            main: blue[800],
        },
        text: {
            primary: '#b3b3b3',
        },
    },
    appBar: {
        //height: appBarHeight,
    },
});


export default function App() {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
              <ToastProvider autoDismissTimeout={3000} autoDismiss={true} placement="top-center" components={{ ToastContainer: MUIToastContainer, Toast: MUIToast }}>
                  <CssBaseline />
                  <AppContent/>
              </ToastProvider>
            </ThemeProvider>
        </Provider>
    );
}

